import dayjs from 'dayjs'
import { changeTimeLocalToUtc } from '../../../helper'
import { DATE_FORMAT } from '../../../utils/constants'

export class ClientDealEnhancedReverseOptionsForm {
  constructor(form, currencyNormalize) {
    this.deal_type = form.deal_type.name
    this.client_side = form.client_side
    this.base_currency = form.currency_pair.substring(0, 3)
    this.counter_currency = form.currency_pair.substring(3, 6)
    this.client = form.client
    this.trade_date = changeTimeLocalToUtc(form.trade_date, DATE_FORMAT.REGULAR_DATE_TIME)
    this.quantity = Number(form.quantity)
    this.client_premium_amount = Number(form.client_premium_amount)
    this.client_premium_currency = form.client_premium_currency.name
    this.client_premium_date = form.client_premium_date
      ? dayjs(form.client_premium_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.put_call = form.put_call
    this.settlement_date = form.settlement_date
      ? dayjs(form.settlement_date).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.fixing_source = form.fixing_source
    this.expiry = form.expiry ? dayjs(form.expiry).format(DATE_FORMAT.REGULAR_DATE) : ''
    if (
      currencyNormalize.data &&
      (currencyNormalize?.data[this.base_currency]?.is_ndf ||
        currencyNormalize?.data[this.counter_currency]?.is_ndf)
    ) {
      this.fixing_date = this.expiry
    }
    this.cut = form.cut
    this.client_trader_name = form.client_trader_name
    this.spot_ref = Number(form.spot_ref)
    this.barrier = Number(form.barrier)
    this.window_start = form.window_start
      ? dayjs(form.window_start).format(DATE_FORMAT.REGULAR_DATE)
      : ''
    this.window_end = form.window_end ? dayjs(form.window_end).format(DATE_FORMAT.REGULAR_DATE) : ''
    this.client_note = form.client_note
    this.trade_origin = 'FXER'
  }
}
